module.exports = __webpack_public_path__ + "img/zhuanNum.8bf39f0f.png";